import script from "./LeftBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftBar.vue?vue&type=script&setup=true&lang=js"

export default script